export default __webpack_public_path__ + "static/media/solta2.6c9938ad.jpg";